import React from "react";
import { Box, Typography } from "@mui/material";

function Home() {
  return (
    <Box
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      <Typography variant="h4">Home</Typography>
    </Box>
  );
}

export default Home;
